import React, { ReactElement } from "react";
import SpinnerIcon from "../icons/SpinnerIcon";
import DotIcon, { DotState, DotSize } from "../icons/DotIcon";

const sizeToCss = {
  mini: "w-4 h-4",
  normal: "w-8 h-8",
  large: "w-10 h-10",
};

interface Props {
  children?: string;
  state: DotState;
  loading?: boolean;
  size?: DotSize;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  opacity?: string;
  gated: boolean;
}

function Dot({
  onClick,
  children,
  state,
  size = "normal",
  loading = false,
  onMouseEnter,
  onMouseLeave,
  opacity,
  gated,
}: Props): ReactElement {
  const sizeCss = sizeToCss[size];

  let content: React.ReactNode;

  content = <DotIcon state={state} label={children} gated={gated} />;
  if (loading) {
    content = <SpinnerIcon />;
  }
  return (
    <div
      className={`${sizeCss} rounded-full grid place-content-center `}
      onKeyDown={() => {
        /* TODO(a11y): do we need this? */
      }}
      tabIndex={0}
      role="button"
      onClick={() => {
        onClick?.();
      }}
      onMouseEnter={() => onMouseEnter?.()}
      onMouseLeave={() => onMouseLeave?.()}
    >
      <div
        className="w-3 h-3 rounded-full grid place-content-center text-white text-xs font-bold leading-none"
        style={{ opacity }}
      >
        {content}
      </div>
    </div>
  );
}

export default Dot;
